/**
 * Created by Jerker Nord on 2018-05-21.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiGameModuleConfig} from "../../IceIceYetiGameModuleConfig";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";
import {IceIceYetiReelSymbol} from "../../symbol/IceIceYetiReelSymbol";

export class IceIceYetiStickySymbolWPController extends WinPresentationController {

    private _overlaySymbolsBeforeSpin:string[][];
    private _overlaySymbolsAfterSpin:string[][];
    private _putStickysOnReel:boolean = false;
    private _newStickySymbolOnLastRespin:boolean = false;
    private _winPresTL:TimelineLite;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "IceIceYetiWildAttentionController", skippable : true});
    }

    protected parseFeatureGameData(data:IceIceYetiParsedGameData):void {
        this._overlaySymbolsBeforeSpin = data.overlaySymbolsBeforeSpin;
        this._overlaySymbolsAfterSpin = data.overlaySymbolsAfterSpin;

        if((data.mode == GameMode.NORMAL && data.nextMode == GameMode.RESPIN) || (data.mode == GameMode.RESPIN && data.nextMode == GameMode.RESPIN)) {
            this._putStickysOnReel = true;
        } else if(data.mode == GameMode.RESPIN) {
            //Last round of respin. Need to check if we won new stickys on last round
            //(If there's no sym positions left to get sticky you won't get a new respin even if you won)
            this._newStickySymbolOnLastRespin = this.newStickysOnReel();
        }
    }

    private newStickysOnReel():boolean {
        let newStickysOnReel:boolean = false;

        for(let i:number = 0; i < this._overlaySymbolsBeforeSpin.length; i++) {
            for(let j:number = 0; j < this._overlaySymbolsBeforeSpin[i].length; j++) {
                if(this._overlaySymbolsBeforeSpin[i][j] != this._overlaySymbolsAfterSpin[i][j]) {
                    newStickysOnReel = true;
                    return newStickysOnReel;
                }
            }
        }

        return newStickysOnReel;
    }

    protected hasWin():boolean {
        //Always true since we always want to check for sticky symbol freeze animations
        return true;
    }

    protected startWinPresentation():void {
        this._winPresTL = new TimelineLite({paused : true, onComplete : () => this.finish()});

        //TODO: Clean up of code here
        if(this._newStickySymbolOnLastRespin == true) {
            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.addNewStickysToAllStickys());

            //Restore original reel symbol under sticky symbol
            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.getNewStickySymbolsTL().play());

            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.killAndResetStickySymAnimation(), "+= " + IceIceYetiGameModuleConfig.StickySymbolWPView.getNewStickySymbolsTL().totalDuration());

            //Set symbols behind stickys to freeze normal state
            let tempReelSymbol:IceIceYetiReelSymbol;
            let tempReelSymName:string;
            for(let i:number = 0; i < this._overlaySymbolsBeforeSpin.length; i++) {
                for(let j:number = 0; j < this._overlaySymbolsBeforeSpin[i].length; j++) {
                    tempReelSymName = this._overlaySymbolsAfterSpin[i][j];
                    if(this._overlaySymbolsBeforeSpin[i][j] != tempReelSymName) {
                        tempReelSymbol = <IceIceYetiReelSymbol>Reels.getSymbol(i, j)!;
                        tempReelSymbol.replaceWith(tempReelSymName, i, IceIceYetiGameConfig.instance.SYMBOL_STATES.frozen);
                    }
                }
            }

            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.killAndResetStickySymAnimation());

            //Respin is over. Clean up sticky symbol overlays
            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.removeAllStickySymbols());

            this._winPresTL.add(() => this._newStickySymbolOnLastRespin = false);
        }

        if(this._putStickysOnReel == true) {

            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.addNewStickysToAllStickys());

            //Restore original reel symbol under sticky symbol
            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.getNewStickySymbolsTL().play());

            //Restores the original sym on reel for spin out + Delay
            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.restoreReelSymbols(), "+= " + IceIceYetiGameModuleConfig.StickySymbolWPView.getNewStickySymbolsTL().totalDuration());

            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.killAndResetStickySymAnimation());

            this._winPresTL.add(() => this._putStickysOnReel = false);
        } else {
            //Respin is over. Clean up sticky symbol overlays
            this._winPresTL.add(() => IceIceYetiGameModuleConfig.StickySymbolWPView.removeAllStickySymbols());
        }

        this._winPresTL.play();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            this._winPresTL.kill();
            IceIceYetiGameModuleConfig.StickySymbolWPView.forceAllNewStickySymbols();
            IceIceYetiGameModuleConfig.StickySymbolWPView.restoreReelSymbols();

            this._putStickysOnReel = false
        }
    }
}